import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ya_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("ya_token")) {
      localStorage.removeItem("ya_token");
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(err);
  }
);

// Resolve a displayable image URL for a photo object
export const photoUrl = (photo, thumb = false) => {
  if (!photo) return "";
  if (photo.external_url) return photo.external_url;
  return `${API}/images/${photo.id}${thumb ? "?thumb=true" : ""}`;
};

export const imageById = (id, thumb = false) =>
  id ? `${API}/images/${id}${thumb ? "?thumb=true" : ""}` : "";

// Format a "HH:MM" 24h time string into 12h AM/PM (e.g. "14:00" -> "2:00 PM")
export const fmtTime = (t) => {
  if (!t || typeof t !== "string" || !t.includes(":")) return t || "";
  const [h, m] = t.split(":").map(Number);
  if (Number.isNaN(h)) return t;
  const ampm = h >= 12 ? "PM" : "AM";
  const h12 = ((h + 11) % 12) + 1;
  return `${h12}:${String(m || 0).padStart(2, "0")} ${ampm}`;
};

export function apiError(err, fallback = "Ocurrió un error. Intenta de nuevo.") {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return fallback;
}

export default api;
